var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact"}},[_c('h1',[_vm._v("Contact")]),_c('FormContainer',{on:{"sendingEmail":function($event){return _vm.updateStatus($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }